import { BaseAPI } from "../base/service";
import { CourseType } from "../enums";
import { Handout } from "./dto";

export class HandoutAPI extends BaseAPI {
    private year = new Date().getFullYear();

    public getList(courseType: CourseType): Promise<Handout[]> {
        return this.api.get(`/${courseType}/${this.year}/extra-content/?tipo=apostila`);
    }
}